var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlashLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7381 0H7.44048H7.14286H6.84524H6.54762L0 25H0.595252H0.892857H1.19048H2.38097H2.97619H4.16667L10.7143 0H10.119H9.52381H8.92857H8.33333H7.7381Z",
    fill: "#42F2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0238 0H21.7262H21.4286H21.1309H20.8333L14.2857 25H14.881H15.1786H15.4762H16.6667H17.2619H18.4524L25 0H24.4048H23.8095H23.2143H22.619H22.0238Z",
    fill: "#42F2F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashLogo);
export default __webpack_public_path__ + "static/media/slash-logo.df494bbb84c804b9337f9ac92bb921b0.svg";
export { ForwardRef as ReactComponent };